// @flow
import { createContext } from 'react';

export type RenewalOfferContextType = {
  residentName: string,
  unitNumber: string,
  leaseId: string,
  previousOffers: Array<Object>,
  leaseTermOptions: Array<Object>,
  propertyTransactionCodes: Array<Object>,
  isLoadingResident: boolean,
  isLoadingTerms: boolean,
  isLoadingOffers: boolean,
  // ENG-30334 — PropertyLeaseTerm id -> REBA's authoritative renewal rent for that term.
  // Only authoritative entries appear: a term REBA does not price, or prices at zero, is simply
  // absent, which the form reads as "leave this tier editable".
  rebaPricingByTermId: { [termId: string]: number },
  // Companion to rebaPricingByTermId; `null` means owned but unresolved, absent means not owned.
  rebaProviderNameByTermId: { [termId: string]: ?string },
  // ENG-31244 — the property's quote-expiration setting (SAME_DAY/HOURS_24/48/72), used to
  // pre-populate the read-only offer expiration date; the server derives its own copy the same way.
  // ENG-31380 — only consumed when the expiration is server-authoritative (see isPartnerEnabled);
  // otherwise it is surfaced but unused.
  quoteExpTime: ?string,
  // ENG-31380 — does the property have a revenue-management provider set up? The API answers from
  // an enabled PartnerConfig reached through PricingPropertyMapping; any provider counts, and an
  // unmapped property answers false.
  isPartnerEnabled: boolean,
};

export const RenewalOfferContext = createContext<RenewalOfferContextType>({
  residentName: '',
  unitNumber: '',
  leaseId: '',
  previousOffers: [],
  leaseTermOptions: [],
  propertyTransactionCodes: [],
  isLoadingResident: false,
  isLoadingTerms: false,
  isLoadingOffers: false,
  rebaPricingByTermId: {},
  rebaProviderNameByTermId: {},
  quoteExpTime: null,
  isPartnerEnabled: false,
});
